<template>
    <svg width="20"
         height="20"
         viewBox="0 0 20 20"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <path d="M8.33325 15L13.3333 10L8.33325 5"
              stroke="#858E97"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'IconChevron',
};
</script>
